import { createFileRoute } from '@tanstack/react-router';
import { Apps } from 'src/apps/device/components';

export const Route = createFileRoute('/_auth/_layout/device/apps/')({
  component: () => <Apps />,
});
